import React from "react";
import { FadeIn } from "../../components/FadeIn";
import { Header } from "../../components/Header";
import { Home } from "../../components/Home";
import { Container } from "../../style/GlobalStyle";

export const HomePage = () => {
  return (
    <Container>
      <Header />
      <FadeIn>
        <Home />
      </FadeIn>
    </Container>
  );
};
